import { useState } from 'react';

import FaqImage from '../../assets/images/FaqImage.png';
import { Button, Divider, Typography } from '../../designComponents';
import FaqAccordion from '../../designComponents/Accordion/FaqAccordion';
import { faqData } from './faqData';
import {
  FAQContainer,
  Head,
  LastSection,
  MainContainer,
  Tab,
  TabsContainer,
  Wrapper,
} from './style';

const categories: any = [
  '1. About Escape Plan',
  '2. Using Escape Plan',
  '3. Materials and Payments',
  '4. Support and Security',
  '5. Feedback and Discounts',
];

const Faqs = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabClick = (index: number) => {
    setSelectedTab(index);
    const selectedCategory = document.getElementById(`faq-category-${index}`);
    if (selectedCategory) {
      window.scrollTo({
        top: selectedCategory?.offsetTop,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      <Head>
        <div className="head-container">
          <Typography className="head-title">
            Answers to Your Queries:{' '}
            <span style={{ color: '#1D8960' }}>Frequently Asked Questions</span>{' '}
            about Escape Plan
          </Typography>
          <Typography className="head-desc ">
            Explore our comprehensive FAQ section to find quick and helpful
            answers to common questions about Escape Plan. Whether you're
            curious about our services, materials used, payment methods, or
            security measures, we've got you covered with clear and informative
            responses.
          </Typography>
        </div>
      </Head>
      <MainContainer>
        <Wrapper>
          <TabsContainer>
            <Typography className="tab-container-title">
              Table of Content
            </Typography>
            {categories.length > 0
              ? categories.map((category: any, index: any) => (
                  <Tab
                    key={index}
                    isActive={index === selectedTab}
                    onClick={() => handleTabClick(index)}
                  >
                    <Typography className="category-tabs-title">
                      {category}
                    </Typography>
                  </Tab>
                ))
              : null}
          </TabsContainer>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <FAQContainer>
              {Array.isArray(faqData) && faqData.length > 0 ? (
                faqData.map((faqCategory, index) => {
                  return (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '50px',
                      }}
                      key={'index'}
                      id={`faq-category-${index}`}
                    >
                      <Typography
                        fontWeight="semibold"
                        className="faq-category"
                      >
                        {faqCategory.category}
                      </Typography>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '15px',
                        }}
                      >
                        {faqCategory.faq.map((faq, i) => (
                          <FaqAccordion key={i}>
                            <FaqAccordion.Header>
                              <Typography
                                style={{
                                  fontSize: '16px',
                                  fontWeight: '500',
                                }}
                              >
                                {faq.title}
                              </Typography>
                            </FaqAccordion.Header>
                            <FaqAccordion.Content>
                              <Typography size={16}>{faq?.content}</Typography>
                              <Divider spaceY="10px" />
                            </FaqAccordion.Content>
                          </FaqAccordion>
                        ))}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography>No FAQ registered yet!!</Typography>
                </div>
              )}
            </FAQContainer>
          </div>
        </Wrapper>
      </MainContainer>
      <LastSection>
        <div className="content">
          <img src={FaqImage} alt="faqImage icon" />
          <Typography className="content-title">
            Still have Questions?
          </Typography>
          <Typography className="content-desc">
            Feel free to reach out to us if you have any further questions or
            need assistance. We're here to help!
          </Typography>
          <Button style={{ borderRadius: '28px' }}>Contact Us Now</Button>
        </div>
      </LastSection>
    </>
  );
};

export default Faqs;
